var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-long-text",domProps:{"innerHTML":_vm._s(_vm.longText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }